import { Box, Tooltip, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  row: any;
  currentlyPlayingId: string | null;
  playCallRecording?: (id: string) => void;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellPlayRecording({ row, currentlyPlayingId, playCallRecording, t }: Props) {
  const isPlaying = currentlyPlayingId === row.id;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {'recordingUrl' in row && typeof row.recordingUrl === 'string' && (
        <Tooltip
          title={row.recordingUrl ? (isPlaying ? t('STOP_RECORDING') : t('PLAY_RECORDING')) : ''}
        >
          <span>
            <IconButton
              color="primary"
              onClick={() => playCallRecording?.(row.id)}
              sx={{
                animation: isPlaying ? 'pulse 1s infinite ease-in-out' : 'none',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.1)',
                  backgroundColor: 'primary.light',
                },
              }}
              disabled={!row.recordingUrl}
            >
              <Iconify icon={isPlaying ? 'solar:stop-circle-bold' : 'solar:play-circle-bold'} />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
}
